import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'

const SmsPackagesWindow = ({ smsPackages, currentSmsPackage, handleSelect, handleClose }) => {
  const { t } = useTranslation(['chat'])

  const getBackgroundColor = (index, disabled) => {
    if (disabled) return '#EAE9E9'
    const colors = ['#4383ff40', '#EAE1EE', '#FBCFFF']
    const colorIndex = index % colors.length
    return colors[colorIndex]
  }

  const getFontColor = (index, disabled) => {
    if (disabled) return '#C9C8C8'
    const colors = ['#1162FF', '#8337FE', '#E113F3']
    const colorIndex = index % colors.length
    return colors[colorIndex]
  }

  return (
    <div className="sms-packages-window">
      <div className={`sms-packages-window__container`}>
        <div className="window-header">
          <div className="left-side">
            <div className="title">{t('chat:smsPackagesWindow.title')}</div>
          </div>
          <div className="right-side">
            <div className="navi-button" onClick={handleClose}>
              <Icon icon="cross" />
            </div>
          </div>
        </div>
        <div className="main-view">
          {smsPackages.map((smsPackage, idx) => {
            const isDisabled =
              currentSmsPackage &&
              smsPackage.packageName === currentSmsPackage.packageName &&
              ['active', 'invoced'].includes(currentSmsPackage.status)
            return (
              <div key={smsPackage.id} className={`sms-package ${isDisabled && 'disabled'}`}>
                <div className="top-side">
                  <div className="package-name">{smsPackage.packageName}</div>
                  <div
                    className="package-cost-container"
                    style={{
                      color: getFontColor(idx, isDisabled),
                      background: getBackgroundColor(idx, isDisabled),
                    }}
                  >
                    <div className="cost">$ {smsPackage.monthlyPrice}</div>
                    <div>{t('chat:smsPackagesWindow.monthly')}</div>
                  </div>
                </div>
                <div className="middle-side">
                  <div className="package-count">
                    {t('chat:smsPackagesWindow.creditsLabel', {
                      credits: smsPackage.packageCredit.toLocaleString(undefined, {
                        useGrouping: true,
                      }),
                    })}
                  </div>
                  <div>{t('chat:smsPackagesWindow.toBeUsedInAllInboxes')}</div>
                </div>
                <button
                  className="button button-black"
                  onClick={() => handleSelect(smsPackage)}
                  disabled={isDisabled}
                >
                  {isDisabled
                    ? t('chat:smsPackagesWindow.currentPackage')
                    : t('chat:smsPackagesWindow.buyNow')}
                </button>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

SmsPackagesWindow.propTypes = {
  smsPackages: PropTypes.array,
  currentSmsPackage: PropTypes.object,
  handleSelect: PropTypes.func,
  handleClose: PropTypes.func,
}

export default SmsPackagesWindow
